import React from "react";
import { FiChevronDown } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import "./BoardsDetailHero.css";

const BoardsDetailHero = ({ board, onReadMore }) => {
  const { i18n } = useTranslation();
  const isRtl = i18n.dir(i18n.language) === "rtl";

  if (!board) return null;

  return (
    <section
      className={`boardsDetailHero${isRtl ? " boardsDetailHero--rtl" : ""}`}
      aria-label={board.heroTitle}
    >
      <div className="boardsDetailHero-container">
        <div className="boardsDetailHero-left">
          <span className="boardsDetailHero-tag">{board.heroTag}</span>

          <h1 className="boardsDetailHero-title">{board.heroTitle}</h1>

          <div className="boardsDetailHero-descWrap">
            <p className="boardsDetailHero-desc is-collapsed">
              {board.heroDescription}
            </p>
            {board.heroDescriptionMore ? (
              <button
                type="button"
                className="boardsDetailHero-readMore"
                onClick={onReadMore}
              >
                Read more
                <FiChevronDown className="boardsDetailHero-readMoreIcon" aria-hidden />
              </button>
            ) : null}
          </div>
        </div>

        <div className="boardsDetailHero-right">
          <div className="boardsDetailHero-photo">
            <img src={board.heroImage} alt="" draggable={false} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BoardsDetailHero;
